import React from "react";
import PropTypes from "prop-types";

const PeriodsTable = ({ periods, handleCloseOpenPeriod, handlePeriodArchive }) => (
  <table className="min-w-full text-sm">
    <thead>
      <tr className="bg-primary-500 text-white">
        <th className="py-2 px-3 w-12 text-center">ID</th>
        <th className="py-2 px-3">Periodo</th>
        <th className="py-2 px-3 w-32 text-center">Estado</th>
        <th className="py-2 px-3 text-center">Acciones</th>
      </tr>
    </thead>
    <tbody>
      {periods.length === 0 ? (
        <tr><td colSpan={4} className="py-4 text-center">No hay periodos contables.</td></tr>
      ) : (
        periods.map(period => (
          <tr key={period.id} className="border-b last:border-b-0 hover:bg-gray-500">
            <td className="py-2 px-3 text-center text-gray-700">{period.id}</td>
            <td className="py-2 px-3 text-gray-800">{period.startDate} - {period.endDate}</td>
            <td className="py-2 px-3 text-center">
              <span className="flex items-center gap-2 justify-center">
                <span className={`inline-block w-3 h-3 rounded-full ${period.status === "open" ? "bg-green-600" : "bg-red-500"}`}></span>
                {period.status === "open" ? "Abierto" : "Cerrado"}
              </span>
            </td>
            <td className="py-2 px-3 text-center">
              {period.status === "open" ? (
                <button type="button" onClick={() => handleCloseOpenPeriod(period, "closed")} className="text-blue-600 hover:underline mr-2">Cerrar Periodo</button>
              ) : null}
              {period.status === "closed" ? (
                <span>
                  <button type="button" onClick={() => handleCloseOpenPeriod(period, "open")} className="text-green-500 hover:underline mr-2">Abrir</button>
                  <button type="button" onClick={() => handlePeriodArchive(period.id)} className="text-red-500 hover:underline">Archivar</button>
                </span>
              ) : null}
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
);

PeriodsTable.propTypes = {
  periods: PropTypes.array.isRequired,
  handleCloseOpenPeriod: PropTypes.func.isRequired,
  handlePeriodArchive: PropTypes.func.isRequired
};

export default PeriodsTable;
